// extracted by mini-css-extract-plugin
export default {"option":"CountryCodeOption_option__vb2hw","img":"CountryCodeOption_img__WS2MY","phoneCode":"CountryCodeOption_phoneCode__7Aece"};